import React, { ComponentType, useEffect, useRef, useState } from 'react'
import { CheckoutPage } from '../../model'
import { useIsDesignLanguage, DesignLanguage, Loader } from '@afterpaytouch/core'
import { ArcadeSummaryPage } from '../summary-arcade'
import { BronteSummaryPage } from '../summary-bronte'
import { SummaryNotificationProvider } from '../../component'
import { useIsAppleRetailOrder } from '../../state/checkout/hooks'
import { AppleRetailSummaryPage } from '../summary-apple-retail'
import { useIsConsumerLendingOrder } from '../../state/consumerLending/hooks'
import { useConsumerFeatureFlagReady } from '../../state/consumer/hooks'
import { PayMonthlySummaryRedesignedPage } from '../summary-pay-monthly-redesign'
import { useAutoRememberMeIssuanceToast } from '../../component/AutoRememberMeIssuanceToast'

const FLAG_PIN_TIMEOUT_MS = 3000

type PayMonthlySummaryRoute = 'appleRetail' | 'payMonthly'

export const SummaryPage: CheckoutPage = () => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const isAppleRetailOrder = useIsAppleRetailOrder()
  const isConsumerLendingOrder = useIsConsumerLendingOrder()
  const hasFeatureFlagsReady = useConsumerFeatureFlagReady()
  const [flagPinTimedOut, setFlagPinTimedOut] = useState(false)

  const pinnedRouteRef = useRef<PayMonthlySummaryRoute | null>(null)
  if (pinnedRouteRef.current === null && isConsumerLendingOrder && (hasFeatureFlagsReady || flagPinTimedOut)) {
    pinnedRouteRef.current = isAppleRetailOrder ? 'appleRetail' : 'payMonthly'
  }
  const pinnedRoute = pinnedRouteRef.current

  useEffect(() => {
    const timer = window.setTimeout(() => setFlagPinTimedOut(true), FLAG_PIN_TIMEOUT_MS)
    return () => window.clearTimeout(timer)
  }, [])

  useAutoRememberMeIssuanceToast()

  let SummaryComponent: ComponentType = BronteSummaryPage

  if (isConsumerLendingOrder) {
    if (pinnedRoute === null) {
      return <Loader alignCenter withHeader />
    }
    SummaryComponent = pinnedRoute === 'appleRetail' ? AppleRetailSummaryPage : PayMonthlySummaryRedesignedPage
  } else if (isAppleRetailOrder) {
    SummaryComponent = AppleRetailSummaryPage
  } else if (isArcadeDesignLanguage) {
    SummaryComponent = ArcadeSummaryPage
  }

  return (
    <SummaryNotificationProvider>
      <SummaryComponent />
    </SummaryNotificationProvider>
  )
}
